<template>
  <div class="disclaimer">
    <div data-scroll-section class="TMSDisclaimerQuestion1_header">
      <PageHeaderBackground bottom-gradient>
        <video src="/assets/videos/investment-products-bg.mp4" type="video/mp4" class="TMSDisclaimerQuestion1_background -desktop" playsinline loop muted autoplay />
        <video src="/assets/videos/investment-products-bg-mobile.mp4" type="video/mp4" class="TMSDisclaimerQuestion1_background -mobile" playsinline loop muted autoplay />
        <div class="TMSDisclaimerQuestion1_backgroundGradient" />
      </PageHeaderBackground>
    </div>
    <div data-scroll-section class="TMSDisclaimerQuestion1_inner">
      <AnimateText tag="h1" appear class="typeH2 TMSDisclaimerQuestion1_heading">
        <span class="typeGradient">Taranis Market Sentiment</span>
      </AnimateText>
      <p class="TMSDisclaimerQuestion1_label">Please select your country of residence:</p>
      <div class="TMSDisclaimerQuestion1_buttonContainer">
        <select v-model="country" id="country-select" class="TMSDisclaimerQuestion1_button">
          <option disabled value="" selected>Choose country</option>
          <option value="Switzerland">Switzerland</option>
          <option value="United Kingdom">United Kingdom</option>
          <option value="other">Other</option>
      </select>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeaderBackground from '@/components/UI/PageHeaderBackground';
import AnimateText from '@/components/Animate/AnimateText.vue';
import FadeIn from '@/components/Animate/FadeIn.vue';
export default {
  name: 'TMSDisclaimerQuestion1',
  components: {
    PageHeaderBackground,
    AnimateText,
    FadeIn
  },
  data () {
    return {
      scroll: null,
      country: '',
    };
  },
  watch: {
    country (newCountry) {
      if (newCountry === 'other')
        this.decline();
      else
        this.accept();
    }
  },
  inject: ['locomotiveScroll'],
  mounted() {
    this.scroll = this.locomotiveScroll();
  },
  methods: {
    accept () {
      this.$store.commit('setDisclaimerTMS', {
        answered1: true,
        answered2: false,
        accepted: false,
        forbidden: false,
      });
      setTimeout(() => {
        this.scroll.scrollTo("top", { duration: 0, disableLerp: true });
        this.scroll.update();
      }, 500);
    },
    decline () {
      this.$store.commit('setDisclaimerTMS', {
        answered1: true,
        answered2: false,
        accepted: false,
        forbidden: true,
      });
      setTimeout(() => {
        this.scroll.scrollTo("top", { duration: 0, disableLerp: true });
        this.scroll.update();
      }, 500);
    }
  }
}
</script>

<style lang="stylus" scoped>
.TMSDisclaimerQuestion1_header {
  position: absolute;
  width: 100%;
  height: 100vh;
}

.TMSDisclaimerQuestion1_inner {
  position: relative;
  width: 100vw;
  min-height: 90vh;
  padding: 20vh var(--respHorPadding) 10vh;
  margin-bottom: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.TMSDisclaimerQuestion1_heading {
  display: inline-block;
  margin-right: auto;
  margin-bottom: 0.75em;
}

.TMSDisclaimerQuestion1_text,
.TMSDisclaimerQuestion1_accept {
  margin-bottom: 3em;
  font-size: 1.2em;
  font-family: "Telegraph";
  font-weight 200;
  color: $lightBlue !important;

  @media (max-width: $breakMd) { font-size: 1em; }
  
  p {
    font: inherit;
    color: $lightBlue !important;
    margin-bottom: 1em;
    line-height: 1.4;
  }

  strong {
    color: $lightBlue !important;
    font-weight: 400;
  }
}

.TMSDisclaimerQuestion1_label {
  GradientText();
  display: block;
  margin-bottom: 1.25em;
  font-size: 1.5em;
  line-height: 1.4;

  @media (max-width: $breakMd) {
    font-size: 1.25em;
  }
}


.TMSDisclaimerQuestion1_background {
  mix-blend-mode: lighten;

  &.-mobile {
    @media (min-width: $breakSm) {
      display: none;  
    }
  }

  &.-desktop {
    @media (max-width: $breakSm) {
      display: none;  
    }
  }
}

.TMSDisclaimerQuestion1_backgroundGradient {
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-image: linear-gradient(to right, rgba($charcoal, 0.85), rgba($charcoal, 0) 75%);
}

.TMSDisclaimerQuestion1_buttonContainer {
  display: flex;
  flex-wrap: wrap;
}

.TMSDisclaimerQuestion1_button {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: auto;
  min-width: 14rem;
  padding: 1em 3em 1em 1em;
  margin-bottom: 0.5em;
  border: 1px solid $blue;
  border-radius: 10px;
  color: $blue;
  font-size: 1.125rem;
  font-family: "Telegraph";
  line-height: 1;
  cursor: pointer;
  margin-right: 1em;
  transition: color 0.05s 0.1s;
  transform: translate3d(0, 0, 0);
  appearance: none;
  background: transparent url('/assets/images/chevron-down.svg') no-repeat center right 1em;
  background-size: 1em;
  
  @media (max-width: $breakSm) {
    flex: 0 0 auto;
    margin: 0;
  }

  &:focus {
    outline: 0;
  }

  option {
    color: black;
  }
}
</style>